import { GButton, GTransition } from 'components/basic-blocks'
import { Tooltip } from '@clickguard/design-system'
import { useStores } from 'hooks'

import { RiArrowGoBackLine } from 'react-icons/ri'

import { useNavigate } from 'react-router-dom'

import { useThemeStore } from 'layout/navbar/store'
import { classNames, removeFromLocalStorage } from 'utils'

export const Impersonation = ({
	footerContent
}: {
	footerContent?: React.ReactNode
}) => {
	const navigate = useNavigate()
	const { userStore, adminStore } = useStores()

	const { theme } = useThemeStore()

	const impersonatedName = adminStore?.impersonation
		? userStore.user?.name
		: undefined

	const stepOut = async () => {
		const id = userStore.user?.id
		await adminStore.clearImpersonation()
		removeFromLocalStorage(['selected_account', 'selected_asset'])
		navigate(`/admin/user/${id}`)
	}

	const BackIcon = () => {
		return <RiArrowGoBackLine className="h-3 w-3 mr-2" />
	}
	const ExitButton = ({ $theme }: { $theme: string }) => (
		<div
			className={classNames(
				'm-4 rounded px-2 py-[6px] text-sm h-[50px]',
				$theme === 'dark' ? 'bg-gray-200' : 'bg-red-100'
			)}
		>
			<div
				className={classNames(
					'flex flex-col gap-y-1',
					$theme === 'dark' ? '' : 'text-t-default'
				)}
			>
				<div className="flex flex-row gap-x-2 items-center">
					<GButton color="danger" size="xs" icon={BackIcon} onClick={stepOut}>
						Exit
					</GButton>
					<span className="text-sm font-light">Viewing as</span>
				</div>
				{impersonatedName && (
					<Tooltip content={impersonatedName} position="bottom" portal>
						<span className="block text-sm font-bold truncate max-w-[130px]">
							{impersonatedName}
						</span>
					</Tooltip>
				)}
			</div>
			{footerContent}
		</div>
	)

	return (
		<GTransition show={adminStore?.impersonation}>
			<ExitButton $theme={theme} />
		</GTransition>
	)
}
